import { Grid } from "@mui/material";
import React from "react";
import Box from "ReusableComponents/Box";
import Text from "ReusableComponents/Text";
import H2 from "ReusableComponents/Text/H2";
import { COLORS, SIZES } from "theme";
import Carousel from "./components/Carousel";

const Testimonials = ({ small, testimonials, info }) => {
  return (
    <Grid
      container
      spacing={2}
      style={{
        width: "auto",
        padding: "24px",
      }}
    >
      <Grid item xs={12}>
        <Box
          margin={small ? "0px" : "24px 0"}
          textAlign="center"
          display="flex"
          flexDirection="column"
        >
          <H2
            textColor="white"
            fontWeight="bold"
            fontSize={small ? SIZES.twenty : "40px"}
            margin="16px 0"
          >
            {info?.attributes?.title}
          </H2>
          {!small && (
            <Box w={small ? "100%" : "600px"} margin="0px auto">
              <Text
                textColor={COLORS.white}
                fontSize={small ? SIZES.fourteen : "17px"}
                margin="0"
              >
                {info?.attributes?.description}
              </Text>
            </Box>
          )}
        </Box>
      </Grid>
      <Grid
        container
        spacing={2}
        style={{
          background: COLORS.lightBlack,
          border: "0px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Carousel small={small} testimonials={testimonials} />
      </Grid>
    </Grid>
  );
};

export default Testimonials;
